import ViewIcon from 'assets/icons/view';
import { IconButton } from '@mui/material';

const FileViewIconButton = ({ onClick, disabled = false }) => {
	return (
		<IconButton sx={{ padding: 0, cursor: 'pointer', width: '34px', height: '34px' }} onClick={onClick} disabled={disabled}>
			<ViewIcon color="#03396c" width="20px" height="20px" />
		</IconButton>
	);
};

export default FileViewIconButton;
